"use state";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faCaretRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
interface NavLink {
  path: string;
  additionalFields: Record<string, any>;
  items?: {
    title: string;
    additionalFields: Record<string, any>;
    path: string;
  }[];
}

interface ResponsiveNavLinkProps {
  link: NavLink;
}
const ResponsiveNavLink: React.FC<ResponsiveNavLinkProps> = ({ link }) => {
  const [showSublinks, setShowSublinks] = useState(false);
  {
    /*const handleClick = () => {
      if (subLinks && subLinks.length > 0) {
        setShowSublinks(!showSublinks);  
      } else {
        window.location.href = path;
      }
    };*/
  }

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowSublinks(!showSublinks);
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between w-full">
        <a
          href={link.path}
          className="flex-1 py-3 px-4 text-gray-700 hover:bg-gray-100 rounded-md"
        >
          {link.additionalFields.view}
        </a>
        {link.items && link.items.length > 0 && (
          <button
            onClick={handleToggle}
            className="p-2 mr-2 focus:outline-none"
            aria-expanded={showSublinks}
            aria-label={`Toggle ${link.additionalFields.view} submenu`}
          >
            <FontAwesomeIcon
              icon={faCaretRight}
              className={`w-4 h-4 transition-transform duration-200 ${
                showSublinks ? "rotate-90" : ""
              }`}
            />
          </button>
        )}
      </div>
      {showSublinks && link.items && (
        <div className="ml-4 mt-1 space-y-1">
          {link.items.map((item) => (
            <a
              key={item.path}
              href={`/${item.path}`}
              className="block py-2 px-4 text-sm text-gray-600 hover:bg-gray-100 rounded-md"
            >
              {item.additionalFields.view}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
export default ResponsiveNavLink;
